export const PreferenceKeys = {
  ListEnquiriesFilters: "ListEnquiriesFilters",
  ListQuotesFilters: "ListQuotesFilters",
  ListJobsFilters: "ListJobsFilters",
};
